module.exports = __webpack_public_path__ + "static/media/pk_red_led.1caff26a.jpg";